import { ThemeProvider, CssBaseline } from '@mui/material';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Login2FA from './pages/Login2FA';
import PaymentList from './pages/PaymentList';
import PaymentDetail from './pages/PaymentDetail';
import AMCRouter from './routes/AMCRouter';
import { RequireAuth } from './components/RequireAuth';
import { RequireAdmin } from './components/RequireRole';
import { UserRole } from './types/user';
import Dashboard from './pages/Dashboard';
import Reports from './pages/Reports';
import Users from './pages/Users';
import MFASetupPrompt from './pages/MFASetupPrompt';
import MFASetup from './pages/MFASetup';
import theme from './AppTheme';
import AuthLayout from './components/AuthLayout';
import SsoMicrosoft from './pages/SsoMicrosoft';
import BankDetails from './pages/BankDetails';
import PaymentCallback from './pages/PaymentCallback';
import SwiftFlowErrors from './pages/SwiftFlowErrors';
import UserManagementHistory from './pages/UserManagementHistory';
import UserLogs from './pages/UserLogs';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
// import Profile from './pages/Profile';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter basename={import.meta.env.BASE_URL}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/login/2fa" element={<Login2FA />} />
          <Route path="/sso/microsoft" element={<SsoMicrosoft />} />
          <Route path="/mfa/setup" element={<MFASetup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/payments/callback" element={<PaymentCallback />} />
          <Route element={<RequireAuth />}>
            <Route element={<AuthLayout />}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/amcs/*" element={<AMCRouter />} />
              <Route path="/payments" element={<PaymentList />} />
              <Route path="/payments/:id" element={<PaymentDetail />} />
              <Route
                element={
                  <RequireAdmin
                    extraRoles={[UserRole.AMC_ADMIN, UserRole.SUPPORT, UserRole.AMC_SUPPORT]}
                  />
                }
              >
                <Route path="/bank-details" element={<BankDetails />} />
              </Route>
              <Route element={<RequireAdmin />}>
                <Route path="/swift-flow-errors" element={<SwiftFlowErrors />} />
              </Route>
              <Route path="/users" element={<Users />} />
              <Route path="/users/history" element={<UserManagementHistory />} />
              <Route path="/user/:userId/logs" element={<UserLogs />} />
              <Route path="/mfa/setup-prompt" element={<MFASetupPrompt />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
